/* Routing */
import {Link, useParams} from "react-router-dom";
/* Components */
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import TabsNavigation from "../../../components/common/navigation/TabsNavigation";
import useAuth from "../../../hooks/useAuth";
import {deleteCmsStepFromDb, getCmsStepList, updateCmsStepStatus} from "../../../api/admin/cmsReq";
import useData from "../../../hooks/useData";
import {useEffect} from "react";
import {getErrorListFromValidation, removeErrorList} from "../../../helper/tools";


export default function CmsSteps() {
    const {auth} = useAuth();
    const token = auth?.token;
    const {cmsStepList, setCmsStepList} = useData();
    const apiCmsStepList = async () => {
        const response = await getCmsStepList(token);
        setCmsStepList(response);
    }
    const sources = "fas fa-balance-scale";

    useEffect(() => {
        apiCmsStepList();
    }, []);

    const handleChangeStepEnabled = async (e) => {
        if (!auth.roles.includes("ROLE_BACKEND")) {
            e.target.setAttribute("disabled", true);
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une étape.");
            e.preventDefault()
            e.target.removeAttribute("disabled");
        } else {
            if (e.target.checked === true) {
                let body = {
                    "stepId": parseInt(e.target.getAttribute("id")),
                    "stepEnabled": true,
                }
                alert("Vous venez de rendre visible cette étape.");
                await updateCmsStepStatus(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiCmsStepList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
            if (e.target.checked === false) {
                let body = {
                    "stepId": parseInt(e.target.getAttribute("id")),
                    "stepEnabled": false,
                }
                alert("Vous venez de rendre invisible cette étape.");
                await updateCmsStepStatus(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiCmsStepList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };

    const handleDeleteCmsStep = (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement une étape.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette étape ?")) {
                const body = {
                    "stepId": parseInt(id),
                }
                return (
                    deleteCmsStepFromDb(token, body)
                        .then((response) => {
                            response.error ? alert("L'étape' n'a pas pu être supprimée.") : alert("L'étape a bien été supprimée.")
                        })
                )
            }
        }
    }

    return (
        <main className="admin">
            <Header parent="Administration"
                    location="Cms : Les démarches"
                    slug="/admin/accueil"
            />
            <TabsNavigation category={1} location="Cms : Les démarches"/>
            <div className="content-container cms-top">
                <Icon source={sources} color="blue" span="CMS Les démarches"/>
                <div className="cms-button">
                    <Link to="0/voir"><button><i className="fa fa-plus"></i> <span>Ajouter</span></button></Link>
                </div>
                <div className="double-fieldset">
                        <table>
                            <thead colspan={4} className="dashboard-header cms-steps">Inhumation</thead>
                            <tr className="column-titles">
                                <td>Numéro</td>
                                <td>Nom</td>
                                <td>Activé</td>
                                <td>Actions</td>
                                <td>Catégorie</td>
                            </tr>
                            <tbody>
                            {cmsStepList?.filter((cmsStep) => (cmsStep?.category == 1)).map((cmsStepInhumation,index) => (
                                cmsStepInhumation ?
                                    <tr key={index}>
                                        <td key={`inhumation-number-${cmsStepInhumation?.id}`}>
                                            {cmsStepInhumation?.number}
                                        </td>
                                        <td key={`inhumation-id-${cmsStepInhumation?.id}`}>
                                            <Link to={`/admin/cms/demarches/${cmsStepInhumation?.id}/voir`}>{cmsStepInhumation?.title}</Link>
                                        </td>
                                        <td>
                                            <label className="switch">
                                                <input id={cmsStepInhumation?.id} type="checkbox"
                                                       defaultChecked={cmsStepInhumation?.enabled}
                                                       onChange={handleChangeStepEnabled}/>
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td key={`inhumation-delete-${cmsStepInhumation?.id}`}
                                            className="admin actions">
                                            <i id={cmsStepInhumation?.id} className="fa fa-trash"
                                               onClick={handleDeleteCmsStep}></i>
                                        </td>
                                        <td><i className="fa fa-person-arrow-down-to-line"/></td>
                                    </tr>
                                    : <span>Pas de démarche disponible</span>
                            ))}
                            </tbody>
                        </table>
                        <table>
                            <thead className="dashboard-header cms-steps">Crémation</thead>
                            <tr className="column-titles">
                                <td>Numéro</td>
                                <td>Nom</td>
                                <td>Activé</td>
                                <td>Actions</td>
                                <td>Catégorie</td>
                            </tr>
                            <tbody>
                            {cmsStepList?.filter((cmsStep) => (cmsStep?.category == 2)).map(cmsStepCremation => (
                                cmsStepCremation ?
                                    <tr>
                                        <td key={`cremation-number-${cmsStepCremation?.id}`}>
                                            {cmsStepCremation?.number}
                                        </td>
                                        <td key={`cremation-id-${cmsStepCremation?.id}`}>
                                            <Link to={`/admin/cms/demarches/${cmsStepCremation?.id}/voir`}>{cmsStepCremation?.title}</Link>
                                        </td>
                                        <td>
                                            <label className="switch">
                                                <input id={cmsStepCremation?.id} type="checkbox"
                                                       defaultChecked={cmsStepCremation?.deletedAt === null}
                                                       onChange={handleChangeStepEnabled}/>
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td key={`cremation-delete-${cmsStepCremation?.id}`}
                                            className="admin actions">
                                            <i id={cmsStepCremation?.id} className="fa fa-trash"
                                               onClick={handleDeleteCmsStep}></i>
                                        </td>
                                        <td><i className="fa fa-fire"/></td>
                                    </tr>
                                    : <span>Pas de démarche disponible</span>
                            ))}
                            </tbody>
                        </table>

                </div>
            </div>

        </main>
    )
}
